var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaguette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16906 7.6211C4.08707 8.47295 2 10.1146 2 12C2 14.7614 2.5 17 12 17C21.5 17 22 14.7614 22 12C22 10.29 20.2831 8.78047 17.6643 7.87887L16.7115 10.7372C16.5805 11.1301 16.1558 11.3425 15.7628 11.2115C15.3699 11.0805 15.1575 10.6558 15.2885 10.2628L16.2208 7.46589C15.2981 7.25079 14.2989 7.10404 13.2492 7.03863C13.2458 7.10468 13.2334 7.17137 13.2115 7.23717L12.2115 10.2372C12.0805 10.6301 11.6558 10.8425 11.2628 10.7115C10.8699 10.5805 10.6575 10.1558 10.7885 9.76282L11.7087 7.00208C10.6629 7.01703 9.65737 7.11227 8.71579 7.2759C8.76141 7.42118 8.76335 7.58166 8.71151 7.73717L7.71151 10.7372C7.58053 11.1301 7.15579 11.3425 6.76283 11.2115C6.36987 11.0805 6.1575 10.6558 6.28849 10.2628L7.16906 7.6211Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaguette);
export default __webpack_public_path__ + "static/media/baguette.5658ed56849733cdb63db6210cf8a117.svg";
export { ForwardRef as ReactComponent };